var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "406.757px",
    height: "389.354px",
    viewBox: "0 0 406.757 389.354",
    enableBackground: "new 0 0 406.757 389.354",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#FFFFFF",
    d: "M21.31,111.763c0,0-27.877,71.987,11.297,144.503 c39.173,72.517,119.878,110.802,184.469,143.549c64.59,32.746,131.661,16.799,163.534-36.838 c31.872-53.637-11.846-91.929-11.897-168.418c-0.051-76.49,11.447-96.741-29.963-161.364 C297.339-31.429,195.691-45.731,118.85,2.198C42.009,50.127,21.31,111.763,21.31,111.763z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Interface"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Bubble"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#28ACE2",
    d: "M192.323,12.317C11.39,22.439-27.446,262.426,33.143,335.815c47.031,56.967,130.88,47.563,175.14-8.193 c36.445-45.912,95.44-11.994,144.073-61.641C415.708,201.311,395.345,0.958,192.323,12.317z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#FFFFFF",
    d: "M192.07,12.317C11.137,22.439-27.699,262.426,32.89,335.815 c47.031,56.967,130.88,47.563,175.14-8.193c36.445-45.912,95.44-11.994,144.073-61.641 C415.456,201.311,395.092,0.958,192.07,12.317z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_150_",
    d: "M353.092,53.284v229.283c0,1.275-1.033,2.299-2.3,2.299H213.17c-1.266,0-2.298-1.023-2.298-2.299 V53.284c0-1.266,1.032-2.299,2.298-2.299h37.929l1.248,4.226h59.27l1.248-4.226h37.928 C352.059,50.985,353.092,52.019,353.092,53.284z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_150_",
    overflow: "visible",
    fill: "#28ACE2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_150_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    clipPath: "url(#XMLID_2_)",
    fill: "#28ACE2",
    d: "M353.092,73.156v209.411c0,1.275-1.033,2.299-2.3,2.299H213.17 c-1.266,0-2.298-1.023-2.298-2.299V73.156H353.092z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#XMLID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#28ACE2",
    d: "M328.961,94.443H210.665v51.454h118.297c1.525,0,2.763-1.237,2.763-2.762v-45.93 C331.724,95.68,330.487,94.443,328.961,94.443z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28ACE2",
    d: "M316.722,149.309H210.665v54.063h106.058c1.603,0,2.901-1.298,2.901-2.901v-48.258 C319.624,150.608,318.325,149.309,316.722,149.309z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28ACE2",
    d: "M328.961,202.313H210.665v51.453h118.297c1.525,0,2.763-1.236,2.763-2.762v-45.93 C331.724,203.549,330.487,202.313,328.961,202.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28ACE2",
    d: "M331.722,259.01v25.856H213.17c-1.266,0-2.298-1.023-2.298-2.299v-26.322h118.084 C330.484,256.245,331.722,257.483,331.722,259.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28ACE2",
    d: "M342.826,97.57v13.217c0,1.154-0.632,2.159-1.563,2.699v171.38h-3.128v-171.38 c-0.931-0.54-1.563-1.545-1.563-2.699V97.57c0-1.722,1.396-3.127,3.127-3.127S342.826,95.848,342.826,97.57z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_150_",
    overflow: "visible",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 210.875,
    y1: 73.353,
    x2: 353.089,
    y2: 73.353
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_618_",
    d: "M316.83,90.691v43.43c0,1.526-1.238,2.764-2.765,2.764H197.358c-1.527,0-2.765-1.237-2.765-2.764v-43.43 c0-1.527,1.238-2.764,2.765-2.764h116.707C315.591,87.928,316.83,89.165,316.83,90.691z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_618_",
    overflow: "visible",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_618_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 200.53,
    y: 93.631,
    clipPath: "url(#XMLID_3_)",
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 39.749,
    height: 37.549
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#XMLID_3_)",
    fill: "#263238",
    d: "M284.485,96.934h-35.571c-0.911,0-1.651-0.739-1.651-1.652l0,0 c0-0.912,0.74-1.651,1.651-1.651h35.571c0.912,0,1.651,0.739,1.651,1.651l0,0C286.136,96.195,285.397,96.934,284.485,96.934z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#XMLID_3_)",
    fill: "#263238",
    d: "M263.553,104.222h-14.64c-0.911,0-1.651-0.74-1.651-1.651l0,0 c0-0.913,0.74-1.652,1.651-1.652h14.64c0.911,0,1.651,0.74,1.651,1.652l0,0C265.205,103.482,264.464,104.222,263.553,104.222z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#XMLID_3_)",
    fill: "#28ACE2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M294.134,122.553c-1.774-0.559-2.86,0.528-3.353,1.227c-0.48-0.707-1.553-1.81-3.335-1.277c-1.934,0.58-2.622,3.034-1.016,5.29 c1.158,1.623,3.032,2.741,3.992,3.238c0.114,0.06,0.219,0.109,0.304,0.149c0.086-0.039,0.191-0.087,0.307-0.145 c0.967-0.483,2.857-1.573,4.036-3.178C296.713,125.625,296.058,123.162,294.134,122.553z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#XMLID_3_)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 307.951,128.208 302.033,128.208 301.433,122.373 308.55,122.373  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 301.643,
    y1: 124.363,
    x2: 308.34,
    y2: 124.363
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 301.858,
    y1: 126.217,
    x2: 308.125,
    y2: 126.217
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 303.672,
    y1: 122.373,
    x2: 303.821,
    y2: 128.208
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 306.311,
    y1: 122.373,
    x2: 306.134,
    y2: 128.208
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 308.515,
    y1: 122.352,
    x2: 310.169,
    y2: 121.752
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 308.761,
    cy: 131.035,
    r: 0.756
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 301.053,
    cy: 131.035,
    r: 0.756
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 301.25,
    y1: 129.241,
    x2: 308.76,
    y2: 129.241
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    clipPath: "url(#XMLID_3_)",
    d: "M310.729,128.21H194.593v5.911c0,1.526,1.238,2.764,2.765,2.764h116.037v-6.008 C313.395,129.404,312.202,128.21,310.729,128.21z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_618_",
    overflow: "visible",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_619_",
    d: "M316.83,193.317v43.438c0,1.525-1.238,2.755-2.765,2.755H197.358c-1.527,0-2.765-1.229-2.765-2.755 v-43.438c0-1.518,1.238-2.755,2.765-2.755h116.707C315.591,190.562,316.83,191.799,316.83,193.317z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_619_",
    overflow: "visible",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_619_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 200.53,
    y: 196.262,
    clipPath: "url(#XMLID_4_)",
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 39.749,
    height: 37.55
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#XMLID_4_)",
    fill: "#263238",
    d: "M284.485,199.565h-35.571c-0.911,0-1.651-0.739-1.651-1.651l0,0 c0-0.912,0.74-1.652,1.651-1.652h35.571c0.912,0,1.651,0.74,1.651,1.652l0,0C286.136,198.826,285.397,199.565,284.485,199.565z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#XMLID_4_)",
    fill: "#263238",
    d: "M263.553,206.853h-14.64c-0.911,0-1.651-0.739-1.651-1.651l0,0 c0-0.913,0.74-1.652,1.651-1.652h14.64c0.911,0,1.651,0.739,1.651,1.652l0,0C265.205,206.113,264.464,206.853,263.553,206.853z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#XMLID_4_)",
    fill: "#28ACE2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M294.134,225.185c-1.774-0.56-2.86,0.527-3.353,1.227c-0.48-0.707-1.553-1.809-3.335-1.276c-1.934,0.58-2.622,3.033-1.016,5.29 c1.158,1.622,3.032,2.74,3.992,3.236c0.114,0.061,0.219,0.11,0.304,0.15c0.086-0.038,0.191-0.088,0.307-0.146 c0.967-0.482,2.857-1.572,4.036-3.178C296.713,228.256,296.058,225.793,294.134,225.185z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#XMLID_4_)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 307.951,230.84 302.033,230.84 301.433,225.003 308.55,225.003  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 301.643,
    y1: 226.994,
    x2: 308.34,
    y2: 226.994
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 301.858,
    y1: 228.849,
    x2: 308.125,
    y2: 228.849
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 303.672,
    y1: 225.003,
    x2: 303.821,
    y2: 230.84
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 306.311,
    y1: 225.003,
    x2: 306.134,
    y2: 230.84
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 308.515,
    y1: 224.982,
    x2: 310.169,
    y2: 224.383
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 308.761,
    cy: 233.666,
    r: 0.756
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 301.053,
    cy: 233.666,
    r: 0.756
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 301.25,
    y1: 231.872,
    x2: 308.76,
    y2: 231.872
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    clipPath: "url(#XMLID_4_)",
    d: "M313.395,190.562H197.358c-1.527,0-2.765,1.237-2.765,2.755v16.512h116.136 c1.473,0,2.666-1.194,2.666-2.667V190.562z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_619_",
    overflow: "visible",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M314.069,290.83H197.356c-1.525,0-2.762-1.236-2.762-2.763v-43.431c0-1.524,1.237-2.762,2.762-2.762h116.712 c1.526,0,2.763,1.237,2.763,2.762v43.431C316.832,289.594,315.595,290.83,314.069,290.83z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.53,
    y: 247.577,
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 39.749,
    height: 37.551
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M284.485,250.881h-35.571c-0.911,0-1.651-0.739-1.651-1.651l0,0c0-0.913,0.74-1.652,1.651-1.652h35.571 c0.912,0,1.651,0.739,1.651,1.652l0,0C286.136,250.142,285.397,250.881,284.485,250.881z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M263.553,258.168h-14.64c-0.911,0-1.651-0.739-1.651-1.651l0,0c0-0.913,0.74-1.65,1.651-1.65h14.64 c0.911,0,1.651,0.737,1.651,1.65l0,0C265.205,257.429,264.464,258.168,263.553,258.168z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28ACE2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M294.134,276.5 c-1.774-0.56-2.86,0.526-3.353,1.227c-0.48-0.707-1.553-1.809-3.335-1.276c-1.934,0.581-2.622,3.033-1.016,5.29 c1.158,1.622,3.032,2.74,3.992,3.237c0.114,0.061,0.219,0.11,0.304,0.15c0.086-0.039,0.191-0.088,0.307-0.146 c0.967-0.482,2.857-1.574,4.036-3.179C296.713,279.572,296.058,277.108,294.134,276.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 307.951,282.155 302.033,282.155 301.433,276.319 308.55,276.319  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 301.643,
    y1: 278.311,
    x2: 308.34,
    y2: 278.311
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 301.858,
    y1: 280.164,
    x2: 308.125,
    y2: 280.164
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 303.672,
    y1: 276.319,
    x2: 303.821,
    y2: 282.155
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 306.311,
    y1: 276.319,
    x2: 306.134,
    y2: 282.155
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 308.515,
    y1: 276.299,
    x2: 310.169,
    y2: 275.699
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 308.761,
    cy: 284.982,
    r: 0.756
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 301.053,
    cy: 284.982,
    r: 0.756
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 301.25,
    y1: 283.188,
    x2: 308.76,
    y2: 283.188
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M306.624,192.763 H156.486c-1.526,0-2.762-1.236-2.762-2.762v-56.817c0-1.526,1.236-2.762,2.762-2.762h150.137c1.524,0,2.762,1.236,2.762,2.762V190 C309.385,191.526,308.148,192.763,306.624,192.763z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.283,
    y: 137.684,
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 50.617,
    height: 47.817
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M268.561,141.89h-46.032c-0.958,0-1.734-0.777-1.734-1.735v-0.735c0-0.958,0.776-1.736,1.734-1.736h46.032 c0.959,0,1.736,0.777,1.736,1.736v0.735C270.297,141.113,269.52,141.89,268.561,141.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M241.906,151.17h-19.377c-0.958,0-1.734-0.777-1.734-1.736V148.7c0-0.959,0.776-1.736,1.734-1.736h19.377 c0.959,0,1.736,0.777,1.736,1.736v0.734C243.642,150.393,242.865,151.17,241.906,151.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28ACE2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M280.481,174.514 c-2.259-0.711-3.642,0.671-4.269,1.563c-0.612-0.9-1.979-2.304-4.247-1.625c-2.463,0.739-3.339,3.863-1.294,6.736 c1.476,2.066,3.862,3.489,5.085,4.122c0.146,0.077,0.278,0.14,0.387,0.191c0.108-0.05,0.244-0.111,0.391-0.186 c1.231-0.614,3.64-2.003,5.14-4.046C283.766,178.426,282.932,175.29,280.481,174.514z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 298.075,181.715 290.54,181.715 289.776,174.285 298.839,174.285  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 290.044,
    y1: 176.82,
    x2: 298.571,
    y2: 176.82
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 290.318,
    y1: 179.18,
    x2: 298.298,
    y2: 179.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 292.627,
    y1: 174.285,
    x2: 292.816,
    y2: 181.715
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 295.989,
    y1: 174.285,
    x2: 295.761,
    y2: 181.715
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 298.795,
    y1: 174.258,
    x2: 300.903,
    y2: 173.494
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 299.107,
    cy: 185.315,
    r: 0.963
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 289.293,
    cy: 185.315,
    r: 0.963
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 289.542,
    y1: 183.032,
    x2: 299.108,
    y2: 183.032
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M324.805,291.702L324.805,291.702c-0.865,0-1.565-0.699-1.565-1.563V93.476c0-0.864,0.7-1.565,1.565-1.565 l0,0c0.864,0,1.565,0.701,1.565,1.565v196.663C326.371,291.003,325.669,291.702,324.805,291.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M324.805,107.402 L324.805,107.402c-1.729,0-3.13-1.401-3.13-3.13V91.058c0-1.729,1.4-3.13,3.13-3.13l0,0c1.729,0,3.129,1.401,3.129,3.13v13.215 C327.934,106.001,326.534,107.402,324.805,107.402z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 265.3433 68.3291)",
    opacity: 0.6,
    fill: "#FFFFFF",
    fontFamily: "'BebasNeue'",
    fontSize: 11.1691
  }, "WISHLIST"), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M44.903,79.715 C44.31,62.73,60.286,48.388,80.585,47.68c20.299-0.707,37.235,12.487,37.828,29.473c0.545,15.648-12.976,29.044-30.98,31.611 c-1.419,9.288,2.967,13.609,2.967,13.609c-10.422-4.321-13.367-13.354-13.367-13.354C59.353,107.346,45.438,95.082,44.903,79.715z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28ACE2",
    d: "M72.338,67.227c5.064-1.448,8.057,1.709,9.396,3.727c1.415-1.965,4.536-5.005,9.541-3.364 c5.431,1.79,7.195,8.787,2.477,15.055c-3.4,4.505-8.793,7.53-11.546,8.864c-0.329,0.161-0.629,0.294-0.874,0.402 c-0.24-0.116-0.535-0.262-0.858-0.436c-2.7-1.438-7.972-4.667-11.188-9.3C64.802,75.731,66.843,68.806,72.338,67.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M69.764,230.593 c0,0-23.906,23.279-31.358,39.114s-3.241,15.15,4.034,20.166c14.604,10.067,45.952,23.021,45.952,23.021s0.621,10.214,5.899,13.629 c5.278,3.416,20.181-16.061,18.007-19.361c-2.173-3.303-17.058-2.255-17.058-2.255s-7.47-2.989-18.025-11.643 c-10.556-8.654-23.596-16.727-23.596-16.727s13.007-18.11,19.909-23.049c6.901-4.939,17.97-12.036,17.97-12.036"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M171.408,364.968c-14.167,4.746-27.737,8.209-39.53,9.121c-0.875,0.064-1.741,0.12-2.597,0.158 c-0.158-2.83-0.409-8.135-0.688-9.765c-0.465-2.689-2.28-4.207-2.28-4.207l-4.97,2.645l-1.377,11.327 c-21.677-0.326-35.425-6.488-35.425-6.488l1.955-11.82c-1.024-3.452-1.396-7.139-1.303-10.937 c0.595-22.077,17.405-47.439,17.405-47.439s38.626-27.254,51.416-5.157C166.792,314.502,171.408,364.968,171.408,364.968z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.393,363.227c-0.242,2.197-14.678,5.156-20.467,0.046c0.549,0.522,5.444,5.203,4.151,6.823 c-1.359,1.723-4.198,0-4.198,0s0.624,1.731,0,3.993c-0.875,0.064-1.741,0.12-2.597,0.158c-0.158-2.83-0.409-8.135-0.688-9.765 c-0.465-2.689-2.28-4.207-2.28-4.207l-4.97,2.645l-1.377,11.327c-21.677-0.326-35.425-6.488-35.425-6.488l1.955-11.82 c-1.024-3.452-1.396-7.139-1.303-10.937c2.363,4.086,6.487,9.401,12.221,10.285c9.493,1.453,16.958-5.314,16.958-5.314 s-2.197-6.124,0-12.146c0,0-1.052,15.339,17.507,17.461c18.085,2.066,21.948-1.918,22.125-2.104 c-0.289,0.419-4.896,7.11-7.623,7.837C146.38,361.021,152.644,361.021,152.393,363.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M171.408,364.965 c0,0-4.613-50.466-17.398-72.559s-51.411,5.155-51.411,5.155s-23.083,34.815-16.105,58.382l-1.952,11.813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M89.063,355.616 c9.328,3.191,20.129,1.964,27.248-2.456"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M117.476,314.867 c0,0-6.996,26.879,0,34.979c6.996,8.101,27.432,8.676,32.955,7.56c5.523-1.115,7.365-4.981,7.365-4.981"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M127.975,318.794 c0,0-1.934,13.748,0.196,20.374l10.048,3.683l8.156-5.4c0,0-0.9-12.764-0.755-18.656 C145.621,318.794,135.467,317.075,127.975,318.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M127.17,333.277 c0,0,6.041-2.281,9.603,2.946c0,0,0.602-5.4,8.848-4.419"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M129.259,321.128 c0,0,12.289-0.801,16.362,0.795"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M94.135,321.177 c0,0-4.794,12.279-4.652,18.653l8.14,3.599l8.726-5.815c0,0,1.431-12.271,2.52-17.488 C108.869,320.125,100.594,319.296,94.135,321.177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M90.114,334.112 c0,0,5.711-2.378,7.683,2.547c0,0,1.69-5.254,8.881-4.646"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M94.673,323.077 c0,0,10.436-1.383,13.692-0.22"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M95.751,312.895 c0,0,11.229-2.009,20.987,5.137c0,0,17.491-10.712,40.136-7.215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M159.748,310.114 c0,0,7.637,25.636,8.733,55.422"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M103.853,361.998 c0,0,12.52-4.602,16.385-7.916c0,0,9.079,8.284,21.753,7.916"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M129.281,374.247 c0,0,0.171-9.671-1.306-10.96c-1.478-1.289-1.858-5.242-1.858-5.242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.313,359.355 c-1.657,1.723-2.578,2.273-4.971,3.563l-1.377,11.329"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M153.963,217.602 c2.63,6.673,27.882,39.79,29.951,49.312c2.07,9.521,1.863,17.801-9.728,14.902c-11.592-2.898-16.48-38.267-29.321-57.128"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M152.784,221.536c1.053-1.361,1.539-2.98,1.013-4.774c0,0-0.895-5.479-3.394-9.574c-2.5-4.095-0.688-8.002-2.363-7.921 c-1.675,0.08-2.02,3.756-2.02,3.756s-3.266-3.648-5.273-4.733c-0.916-0.494-6.684-2.856-6.684-2.856l-5.892,0.286 c0,0-0.053,2.783,5.362,2.465l3.609,2.865c0,0-3.405,1.012-3.582,2.535c-0.178,1.523-2.033,1.656-1.843,3.703 c0.19,2.048-0.76,2.351,0.943,4.992c2.045,3.173,4.127,2.132,4.127,2.132s1.731,8.95,3.612,10.7 c0.957,0.891,2.946,1.026,5.115,0.566"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M133.561,203.584 c0,0,2.086,4.768,3.323,6.02c1.237,1.25,3.448-0.067,4.295-0.174c1.089-0.137,1.848,0.013,1.675-0.45 c-0.926-2.474-3.567-1.82-3.567-1.82s-0.784-2.628-2.341-3.702"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M146.021,203.022 c0,0-0.131,1.466,0.355,3.642c0,0-1.786,4.151-1.472,6.109"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M131.725,207.637 c0.779,1.762,2.553,4.146,4.031,4.518c1.478,0.368,6.618-1.07,6.213-2.789"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M137.96,204.477 c0,0,1.068-0.021,1.07-1.724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M137.143,201.049 c0,0,2.118,0.746,3.074-0.916"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M84.149,152.9 c4.989-17.126,35.601-16.733,42.638-3.002c7.038,13.73,4.14,10.662,4.554,15.508c0.414,4.845,4.14,8.396,3.312,16.763 c-0.828,8.367-0.414,11.54-2.484,13.679c-2.069,2.139-17.266-0.255-20.431-2.163C111.738,193.686,75.456,182.74,84.149,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M94.696,184.493 c2.286,4.802,3.033,24.879-1.687,29.64c0,0,12.459,5.38,30.26-1.036c0,0-5.382-6.828-5.382-12.729 c0-5.899,6.831-6.727,6.831-6.727"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M131.083,161.116c0.727,0.456-1.075,3.957-3.415,5.378h1.708c0,0-0.932,3.241-1.708,3.552s-2.95-7.88-8.228-3.552 C119.44,166.494,121.303,154.98,131.083,161.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28ACE2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M115.403,136.792c0,0,13.662,2.206,17.076,10.899c3.416,8.693-2.801,17.682-7.762,18.803c-7.761,1.754-7.141,10.402-4.347,17.999 c2.794,7.596,7.348,13.03,6.105,20.792c0,0-4.82-5.714-8.235-2.109c-3.416,3.606-7.262,3.955-14.635,2.282 c-7.374-1.672-7.182,0.932-10.597,3.087c-3.416,2.155-10.671-4.61-11.292,0.621c-0.621,5.231-2.639,5.732-2.639,5.732 s-9.625-5.961-6.83-14.529c2.794-8.567,5.588-10.689,4.346-17.868c-1.242-7.177-3.104-19.839-0.31-32.602 C79.078,137.135,102.068,130.95,115.403,136.792z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M125.856,170.252c0,0-1.138-6.105-2.38-6.105c-1.242,0-1.759,4.102-1.759,4.102s-1.466,1.607-1.552,5.316 c-0.086,3.708,2.38,4.968,2.38,4.968s1.138,3.519,3.312,2.794c2.173-0.725-2.07-3.519-1.966-12.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M125.959,185.336c0,0,0.466,5.744,4.036,9.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M129.577,152.29 c-1.521,3.127-4.068,5.136-6.745,7.234c-7.657,6.002-19.062,11.833-19.237,23.073c-0.036,2.306,0.487,4.584,1.361,6.709"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M116.755,192.332 c0.246,1.451,0.5,2.902,0.721,4.358"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M120.162,169.249 c-5.894,4.374-4.847,13.503-3.922,19.828"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M93.405,161.759 c1.569,12.328,3.431,25.359-2.256,37.368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M113.732,137.512 c-3.777-0.236-7.835,0.365-11.249,2.032c-6.998,3.416-8.521,11.513-8.962,18.625"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M80.229,199.005 c-0.368,1.505-0.552,3.063-0.417,4.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M80.158,153.272 c-0.644,7.352,0.032,14.738,0.992,22.032c0.481,3.654,1.038,7.297,1.545,10.947c0.495,3.562-0.515,6.688-1.663,10.039"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M82.804,143.035 c-1.455,2.099-1.921,4.899-2.292,7.371"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M117.748,199.608 c1.934-0.94,3.943-0.642,5.571,0.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M98.082,200.279 c3.103-0.48,5.744,1.492,8.558,2.406c3.146,1.021,5.648,0.316,8.349-1.456"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M76.789,209.833 c1.731,0.553,2.14-1.896,2.654-3.014c0.98-2.125,1.678-2.544,3.999-2.011c5.389,1.235,8.801,2.455,12.215-2.671"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M74.421,221.08c0,0,11.177-8.846,31.358-10.536c20.181-1.689,33.531-0.442,38.499,4.522 c4.968,4.966,13.472,22.337,13.558,30.734c0.054,5.283-6.273,20.181-6.273,20.181l9.455,43.275c0,0-27.429-2.087-52.152,0.087 c-12.56,1.105-15.854,3.551-15.854,3.551s5.318-18.775,6.25-23.375C100.19,284.92,69.764,237.343,74.421,221.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M184.386,278.46 c-1.92,9.979-5.439,7.908-12.063,4.804c-6.623-3.104-17.821-14.281-30.333-30.425l14.352-17.965c0,0,11.22,15.895,15.981,21.069 c4.761,5.175,7.451,13.039,7.451,13.039"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M124.718,210.139c0,0,12.083-1.249,18.161,3.782c6.078,5.029,12.986,17.738,16.869,23.568 c0,0-8.073,14.936-17.515,17.418c0,0-4.028-6.623-7.459-8.692c-3.432-2.07-6.602-7.037-6.602-7.037"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M82.985,216.245c-10.116,3.166-20.051,19-25.95,24.278c0,0,4.143,11.57,16.493,15.813 c0,0,6.223-5.259,9.457-4.016C86.219,253.563,82.985,216.245,82.985,216.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M129.996,145.121 c0.066,1.399,0.153,2.8,0.118,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M53.619,276.538 c0,0-3.341,4.638-8.497,4.454"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M141.991,252.839 c0,0-4.829-8.823-7.218-8.669c-2.389,0.156-6.864-15.634,2.37-26.568"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M91.149,214.897 c0,0,5.681,4.618,26.693-2.124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M91.149,224.287 c0,0,15.629-0.361,23.218-6.686"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M73.501,227.479 c0,0-1.578,17.8,9.323,22.523"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M70.729,244.17 c0,0,2.447,6.263,10.636,5.832"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.313,237.542 c0,0,1.082,7.418,11.126,8.497"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M102.599,285.823 c0,0,24.662-4.585,28.637-12.441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M108.365,292.283 c0,0,8.751,11.783,23.2,9.083"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.9546a9067bb0a02ccd739c37ea6b1bfd.svg";
export { ForwardRef as ReactComponent };